import { SxProps, TableCell, TableCellProps, Theme } from "@mui/material"
import { PropsWithChildren } from "react"

export const RPMTableHeaderCell = ({
    children, ...props
}: PropsWithChildren<TableCellProps>) => {

    const sx: SxProps<Theme> = {
        ...props.sx,
        fontWeight: 'bold'
    };

    return (
        <TableCell
            sx={sx}
            {...props}
        >
            {children}
        </TableCell>
    )
}
